import { useState } from "react";
export function useGetGeoLocation() {
    const [location, setLocation] = useState(null);
  
    const getLocation = () => {
      if (!navigator.geolocation) {
        alert("Geolocation is not supported by your browser");
        return;
      }
  
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => {
          alert(err.message);
        }
      );
    };

  return {
    location,
    getLocation,
  };
}
